module.exports = "https://trybtryb-legacy.web.app/img/oval-desktop.e53bfb96.svg";